import React from "react";
import { SDLCMetadataTypeGuards } from "@sscs/types";
import { Checkbox, IconButton, InputAdornment, List, Menu, Select, } from "@sscs/ui";
import { CloseIcon } from "@sscs/ui/icons";
import { capitalizeFirstLetter } from "@sscs/utils";
import { PREVALENCE_TO_TEXT } from "../../../utils";
import styles from "./prevalenceFilter.module.scss";
const PrevalenceFilter = ({ prevalence, className, onChange, }) => {
    const prevalenceOptionsOrder = [
        "behavior-common",
        "behavior-uncommon",
        "behavior-anomalous",
        "behavior-important",
        "behavior-malicious",
        "unknown",
    ];
    return (React.createElement(Select, { multiple: true, displayEmpty: true, shrinkLabel: true, id: "prevalence-filter", labelId: "prevalence-filter-label", label: "Filter by prevalence", value: prevalence, renderValue: (value) => {
            if (Array.isArray(value)) {
                if (value.length === 0) {
                    return "Show all prevalence";
                }
                return value
                    .map((item) => SDLCMetadataTypeGuards.stringIsBehaviorPrevalence(item)
                    ? PREVALENCE_TO_TEXT[item]
                    : capitalizeFirstLetter(item))
                    .join(", ");
            }
            else {
                return undefined;
            }
        }, onChange: (value) => onChange(value), endAdornment: prevalence.length > 0 ? (React.createElement(InputAdornment, { position: "end" },
            React.createElement(IconButton, { className: styles["close-icon"], size: "small", onClick: () => onChange([]) },
                React.createElement(CloseIcon, null)))) : undefined, classes: { select: styles.select }, className: `${styles.prevalence} ${className}` }, prevalenceOptionsOrder.map((option) => (React.createElement(Menu.Item, { key: option, value: option },
        React.createElement(Checkbox, { checked: prevalence.includes(option) }),
        React.createElement(List.ItemText, { primary: option !== "unknown" ? PREVALENCE_TO_TEXT[option] : "Unknown" }))))));
};
export default PrevalenceFilter;
//# sourceMappingURL=PrevalenceFilter.js.map